<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li
          class="nav-item m-tabs__item"
          v-show="!this.customerStats || this.customerStats == 'cnpj'"
        >
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_customer"
            role="tab"
          >
            <h6><span class="far fa-building"></span> Pessoa jurídica</h6>
          </a>
        </li>
        <li
          class="nav-item m-tabs__item"
          v-show="!this.customerStats || this.customerStats == 'cpf'"
        >
          <a
            class="nav-link m-tabs__link"
            data-toggle="tab"
            href="#save_customer_physical"
            role="tab"
          >
            <h6><span class="fas fa-user-hard-hat"></span> Pessoa física</h6>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="customerId > 0">
          <a class="nav-link m-tabs__link" data-toggle="tab" href="#save_contacts" role="tab">
            <h5><span class="far fa-phone"></span> Contatos</h5>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="customerId > 0">
          <a class="nav-link m-tabs__link" data-toggle="tab" href="#customer_history" role="tab">
            <h5><span class="far fa-history"></span> Histórico</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div
          class="tab-pane"
          :class="{
            active:
              !this.customerStats ||
              this.customerStats == 'cnpj' ||
              this.customerStats == 'international',
          }"
          id="save_customer"
          role="tabpanel"
        >
          <CustomerSaveForm />
        </div>
        <div
          class="tab-pane"
          :class="{ active: this.customerStats == 'cpf' }"
          id="save_customer_physical"
          role="tabpanel"
        >
          <CustomerSaveFormPhysical />
        </div>

        <div class="tab-pane" id="save_contacts" role="tabpanel">
          <CustomerContactForm />
        </div>

        <div class="tab-pane" id="customer_history" role="tabpanel">
          <CustomerHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerSaveForm from '@/components/customers/CustomerSaveForm';
import CustomerSaveFormPhysical from '@/components/customers/CustomerSaveFormPhysical';
import CustomerContactForm from '@/components/customers/CustomerContactForm';
import CustomerHistory from '@/components/customers/CustomerHistory';

export default {
  name: 'CustomerModal',
  components: {
    CustomerSaveForm,
    CustomerContactForm,
    CustomerSaveFormPhysical,
    CustomerHistory,
  },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showCustomerSave = null;
      this.$store.state.showStatsCustomer = null;
    },
  },
  computed: {
    customerId() {
      return this.$store.state.showCustomerSave;
    },
    customerStats() {
      return this.$store.state.showStatsCustomer;
    },
  },
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
